import { Component, Inject, OnInit } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as moment from 'moment';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Observable } from 'rxjs/internal/Observable';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatRadioChange } from '@angular/material/radio';
import { Clipboard } from "@angular/cdk/clipboard";
import { SendEmailNotificationComponent } from '../sendEmailNotification/sendEmailNotification.component';

@Component({
  selector: 'app-uploadAIDocuments',
  templateUrl: './uploadAIDocuments.component.html',
  styleUrls: ['./uploadAIDocuments.component.scss'],
})

export class UploadAIDocuments implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;
  transactionName: string = "";
  aITemplateList: any = [] = [];
  selectedFunction: any;
  transactionId: any;
  uploadedFiles: File[] = [];
  fieldTemplateID: number = 0;

  constructor(public dialogRef: MatDialogRef<UploadAIDocuments>,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,
    private toastr: ToastrService, private statusConstant: StatusConstant,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderService: LoaderService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    this.transactionName = this.data.Name;
    this.transactionId = this.data.transactionID;
    this.getAIAutomationTemplates();
  }

  getAIAutomationTemplates() {
    this.loaderService.show();
    var ReqModel = {
      keyword: "",
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.coreService.getAIAutomationTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.aITemplateList = this.responseHolder.data.templates;
          if (this.aITemplateList == null) {
            this.aITemplateList = [];
          }
        }
        else {
          this.aITemplateList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.aITemplateList = [];
        this.loaderService.hide();
      }
    });
  }

  closepopup() {
    this.dialogRef.close();
  }

  // onFileSelected(event: any) {
  //   const files: FileList = event.target.files;
  //   for (let i = 0; i < files.length; i++) {
  //     this.uploadedFiles.push(files[i]);
  //   }
  // }

  removeFile(index: number) {
    this.uploadedFiles.splice(index, 1);
  }

  onTemplateSelect(event: any) {
    this.fieldTemplateID = event.value;
  }


  parentId: number = 0;


  engagingMessages = [
    "Hang tight, we're uploading your file!",
    "Almost there! Your data is on its way.",
    "We’re making progress. Just a bit more patience!",
    "Your file is getting uploaded smoothly.",
    "Crunching data… great things take time!",
    "Uploading… this won’t take long!",
  ];

  showEngagingToaster = (fileName: string) => {
    let messageIndex = 0;
    const toastId = `upload-progress-${fileName}`;

    // Update the engaging message periodically
    const intervalId = setInterval(() => {
      if (messageIndex < this.engagingMessages.length) {
        this.toastr.clear();
        this.toastr.info(this.engagingMessages[messageIndex], '', {
          disableTimeOut: true,
          closeButton: true,
        });
        messageIndex++;
      } else {
        // Loop the messages once all are shown
        messageIndex = 0;
      }
    }, 5000); // Change message every 2 seconds

    return intervalId;
  };

  clearEngagingToaster = (intervalId: any, finalMessage: string) => {
    clearInterval(intervalId); // Stop the interval updates
    this.toastr.clear(); // Clear the previous toast
    this.toastr.success(finalMessage, '', { timeOut: 3000 }); // Show the success message
  };

  fileUploaded: boolean = false;

  async processWithAI(){
  // this.forSingleUpload();
   if(this.fieldTemplateID>0)
   {
    if(this.uploadedFiles.length==1){
      this.forSingleUpload();
    }
    if(this.uploadedFiles.length>1){
      this.forMultipleUpload();
    }
   }
   else
   {
     this.forSingleUpload();
   }
 }

  forSingleUpload(){
    this.loaderService.show();
    const chunkSize = 10 * 1024 * 1024; // 5 MB per chunk
    const UploadedFilesDragZone = this.uploadedFiles;//Array.from(input.files); // Convert FileList to Array

    const processFile = async (file: File) => {
      // Remove brackets, hash, comma, and special characters except underscore and dot (for file extension)
      const fileName = file.name.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

      // Validate file name length
      if (fileName.split('.')[0].length > 120) {
        this.toastr.warning(
          'File name up to 120 characters only supported, please rename the file.',
          '',
          { timeOut: 3000 }
        );       
        this.loaderService.hide();
        return;
      }

      var newfilename = fileName.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');

      var documentNameSplit = newfilename.split('.');

      const documentName = documentNameSplit[0];
      const documentType = documentNameSplit[1];

      const totalChunks = Math.ceil(file.size / chunkSize);

      let intervalId: any;
      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append('fileChunk', chunk);
        formData.append('chunkIndex', i.toString());
        formData.append('totalChunks', totalChunks.toString());
        formData.append('fileName', fileName);
        formData.append('FileDetailList', `${documentName}|${documentType}`);
        formData.append('ParentID', this.parentId.toString());
        formData.append('UserID', this.currentUser.UID);
        formData.append('OrganizationID', this.organizationId);
        formData.append('OfficeID', this.myOfficeID);
        formData.append('DatabaseID', this.databaseId);
        formData.append('coreId', this.transactionId.toString());
        formData.append('templateId', this.fieldTemplateID.toString());
        formData.append('requestFrom', "1");
        try {
          this.fileUploaded = false;
          const response = await this.coreService.uploadChunkForMultipleUploadWithSelectedTemplate(formData).toPromise();
          if (response?.data === 2) {
            this.fileUploaded = true;
            this.toastr.warning(`${fileName} already exists.`, '', {
              timeOut: 2000,
            });
          } else {
            if (i + 1 == totalChunks) {
              intervalId = this.showEngagingToaster(fileName);
            }
            this.toastr.clear();
            this.toastr.info(`Chunk ${i + 1}/${totalChunks} uploaded for ${fileName}`, '', {
              timeOut: 1000,
            });
          }
        } catch (error) {
          this.loaderService.hide();
          this.toastr.error(`An error occurred during chunk upload for ${fileName}.`, '', {
            timeOut: 3000,
          });
          return;
        }
      }
      if (intervalId)
        if (this.fileUploaded == false) {
          this.clearEngagingToaster(intervalId, `File ${fileName} uploaded successfully!`);
          this.closepopup();
        }
    };

    const uploadFiles = async () => {
      for (const file of UploadedFilesDragZone) {
        await processFile(file);
      }
      this.loaderService.hide();
    };

    uploadFiles();
  }
 

  async forMultipleUpload() {
  this.loaderService.show();
  const chunkSize = 10 * 1024 * 1024; // 10 MB per chunk
  const UploadedFilesDragZone = this.uploadedFiles;

  const formData = new FormData();
  let fileChunkCounter = 0;

  for (const file of UploadedFilesDragZone) {
    const fileName = file.name.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

    // Validate filename
    if (fileName.split('.')[0].length > 120) {
      this.toastr.warning(
        'File name up to 120 characters only supported, please rename the file.',
        '',
        { timeOut: 3000 }
      );
      this.loaderService.hide();
      return;
    }

    const newfilename = fileName.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
    const documentNameSplit = newfilename.split('.');
    const documentName = documentNameSplit[0];
    const documentType = documentNameSplit[1];
    const totalChunks = Math.ceil(file.size / chunkSize);

    for (let i = 0; i < totalChunks; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);

      // Append each chunk as a separate entry in the FileChunks list
      formData.append(`FileChunks[${fileChunkCounter}].FileChunk`, chunk);
      formData.append(`FileChunks[${fileChunkCounter}].FileName`, fileName);
      formData.append(`FileChunks[${fileChunkCounter}].ChunkIndex`, i.toString());
      formData.append(`FileChunks[${fileChunkCounter}].TotalChunks`, totalChunks.toString());
      formData.append(
        `FileChunks[${fileChunkCounter}].FileDetail`,
        `${documentName}|${documentType}`
      );

      fileChunkCounter++;
    }
  }

  // Common metadata (once per request)
  formData.append('ParentID', this.parentId.toString());
  formData.append('UserID', this.currentUser.UID);
  formData.append('OrganizationID', this.organizationId.toString());
  formData.append('OfficeID', this.myOfficeID.toString());
  formData.append('DatabaseID', this.databaseId.toString());
  formData.append('CoreId', this.transactionId.toString());
  formData.append('TemplateId', this.fieldTemplateID.toString());
  formData.append('RequestFrom', '1');

  try {
    const response = await this.coreService
      .uploadChunkForMultipleFiles(formData)
      .toPromise();

    if (response?.data === 2) {
      this.toastr.warning(`Some files already exist.`, '', { timeOut: 2000 });
    } else {
      this.toastr.success(`All files uploaded successfully!`, '', { timeOut: 2000 });
    }

    this.closepopup();
  } catch (error) {
    this.toastr.error(`An error occurred during chunk upload.`, '', { timeOut: 3000 });
  } finally {
    this.loaderService.hide();
  }
  }

//  uploadedFiles: File[] = [];
isDragging = false;

onFileSelected(event: any) {
  const files: FileList = event.target.files;
  this.addFiles(files);
}

onDragOver(event: DragEvent) {
  event.preventDefault(); // necessary to allow dropping
  this.isDragging = true;
}

onDragLeave(event: DragEvent) {
  event.preventDefault();
  this.isDragging = false;
}

onDrop(event: DragEvent) {
  event.preventDefault();
  this.isDragging = false;

  if (event.dataTransfer && event.dataTransfer.files.length > 0) {
    this.addFiles(event.dataTransfer.files);
    event.dataTransfer.clearData();
  }
}

private addFiles(files: FileList) {
  for (let i = 0; i < files.length; i++) {
    this.uploadedFiles.push(files[i]);
  }
}



}


